// Checks the user agent to detect mobile browsers:
// Checking for "Mobi" as recommended here: https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent#mobile_tablet_or_desktop
export const isMobileDevice = () => !!navigator.userAgent.match(/Mobi/i);
